export const disabledOneTimePassword = {
    isSupported: false,
    otpFormat: null,
    request: async function (signal: AbortSignal): Promise<string> {
        throw new Error("OTP is disabled");
    },
};
